import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import GlobalSubnav from '@starbucks-web/pattern-library/lib/components/global-subnav';
import { pathnameSelector } from 'shared/app/state/selectors/routes';
import messages from './messages';

const RewardsSubnav = () => {
  const { formatMessage } = useIntl();
  const routePath = useSelector(pathnameSelector);
  const subNavLinks = [
    {
      active: routePath === '/rewards/my-rewards',
      to: '/rewards/my-rewards',
      children: formatMessage(messages.subnavTabMyRewards),
      tagName: Link,
      className: 'mr3 sm-mr5',
    },
    {
      active: routePath === '/rewards',
      to: '/rewards',
      children: formatMessage(messages.subnavTabHowItWorks),
      tagName: Link,
      className: 'mr3 sm-mr5',
    },
  ];

  return (
    <GlobalSubnav
      ariaLabel={formatMessage(messages.subnavAria)}
      className={`width-100 styles.globalSubnav`}
      items={subNavLinks}
    />
  );
};

export default RewardsSubnav;
